<template>
    <div>
        <notification-modal :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            messageTitle: 'Last minute cancellation',
            message: "Cancellations with less than 24 business hours cannot be completed through the portal. Please contact our team immediately at <u>appts@excelinterpreting.com</u> or call <u>1 (800) 915-0638 ext 101</u>",
            notificationType: 'error',
            firstAction: 'close',
            firstActionText: '&nbsp;&nbsp;&nbsp;OK&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showLastMinuteCancel'
        }
    },
}
</script>